import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { EyeIcon, UsersIcon, PlayIcon, MoonIcon } from 'lucide-react';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const results = [{
    icon: EyeIcon,
    text: 'Clearer eyes and better eye contact'
  }, {
    icon: PlayIcon,
    text: 'Plays independently for 15+ minutes'
  }, {
    icon: UsersIcon,
    text: 'Engages more with family'
  }, {
    icon: MoonIcon,
    text: 'Goes to sleep without power struggles'
  }];
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background-alt)'
  }} data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-3xl md:text-4xl font-bold mb-4 text-center" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-92">
          What Changes in 48 Hours
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="text-center text-lg mb-12 opacity-70" style={{
        color: 'var(--color-text)'
      }} data-id="element-93">
          By Sunday evening, most parents report these transformations:
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.2
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-94">
          {results.map((result, index) => <div key={index} className="flex items-center gap-4 p-5 rounded-lg" style={{
          backgroundColor: 'var(--color-background)',
          border: '1px solid var(--color-border)'
        }} data-id="element-95">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'var(--color-accent)'
          }} data-id="element-96">
                <result.icon className="w-5 h-5 text-white" data-id="element-97" />
              </div>
              <span className="font-medium" style={{
            color: 'var(--color-text)'
          }} data-id="element-98">
                {result.text}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}